import { fetchWithAuth } from '../apiClient';

export async function deleteSchedule(originJobKey, toast, refreshSchedules) {
  try {
    const response = await fetchWithAuth(
      `/scheduler/${originJobKey}/TestingGroup`,
      { method: 'DELETE' }
    );
    if (response.status === 204) {
      toast({
        title: 'Reminder removed.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      if (typeof refreshSchedules === 'function') {
        await refreshSchedules();
      }
    } else {
      throw new Error('Delete failed');
    }
  } catch (err) {
    toast({
      title: 'Error deleting schedule.',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  }
}

export async function completeSchedule(originJobKey, toast, refreshSchedules, details) {
  try {
    const response = await fetchWithAuth('/api/activity', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Status: "complete",
        Type: "action",
        OriginJobKey: originJobKey,
        FiringJobKey: originJobKey,
        FiredTime: new Date().toISOString(),
        Success: true,
        Action: "complete",
        Source: "user",
        Details: details?.trim() ? details : "Completed! 🎉",
      }),
    });
    if (response.ok) {
      toast({
        title: 'Completed! 🎉',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      if (typeof refreshSchedules === 'function') {
        await refreshSchedules();
      }
      // Removed window.location.reload() to avoid jarring full page refresh
      // Instead, rely on refreshSchedules to update UI discreetly
    } else {
      toast({
        title: 'Error recording activity.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  } catch (error) {
    console.error('Error recording activity:', error);
    toast({
      title: 'Error recording activity.',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  }
}

export async function pauseSchedule(originJobKey, toast, refreshSchedules, details) {
  try {
    const response = await fetchWithAuth('/api/activity', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Status: "paused",
        Type: "action",
        OriginJobKey: originJobKey,
        FiringJobKey: originJobKey,
        FiredTime: new Date().toISOString(),
        Success: true,
        Action: "pause",
        Source: "user",
        Details: details?.trim() ? details : "Paused",
      }),
    });
    if (!response.ok) {
      throw new Error('Failed to pause schedule.');
    }
    toast?.({
      title: 'Reminders paused.',
      status: 'info',
      duration: 3000,
      isClosable: true,
    });
    await refreshSchedules?.();
  } catch (error) {
    console.error('Error recording pause activity:', error);
    toast?.({
      title: 'Error pausing reminders.',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
    throw error;
  }
}

export async function resumeSchedule(originJobKey, toast, refreshSchedules, details) {
  try {
    const response = await fetchWithAuth('/api/activity', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Status: "resumed",
        Type: "action",
        OriginJobKey: originJobKey,
        FiringJobKey: originJobKey,
        FiredTime: new Date().toISOString(),
        Success: true,
        Action: "resume",
        Source: "user",
        Details: details?.trim() ? details : "Resumed",
      }),
    });
    if (!response.ok) {
      throw new Error('Failed to resume schedule.');
    }
    toast?.({
      title: 'Reminders resumed.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    await refreshSchedules?.();
  } catch (error) {
    console.error('Error recording resume activity:', error);
    toast?.({
      title: 'Error resuming reminders.',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
    throw error;
  }
}

export async function updateSchedule(originJobKey, instruction, toast, refreshSchedules) {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endpoint = `/scheduler/update/${encodeURIComponent(originJobKey)}/TestingGroup?instruction=${encodeURIComponent(instruction)}&timezone=${encodeURIComponent(timezone)}`;
    const res = await fetchWithAuth(endpoint, { method: 'POST' });
    if (!res.ok) throw new Error('Update failed');
    toast?.({ title: 'Updated', status: 'success', duration: 2500, isClosable: true });
    await refreshSchedules?.();
  } catch (err) {
    toast?.({ title: 'Error updating', status: 'error', duration: 3000, isClosable: true });
    throw err;
  }
}
